"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Theme = _interopRequireDefault(require("../../Theme"));

var _DesktopInput = _interopRequireDefault(require("./DesktopInput.proptypes"));

var _excluded = ["dayValue", "tabIndex", "theme", "placeholder", "dateFormat", "value", "variableWidth", "alignContentRight", "isOnlyApplyForHotel", "enableFontSizeChange"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/*
Convert dateFormat prop to mask which is used by InputMask
E.g:
     dateFormat = 'dd-MM-yyyy' => '99-99-9999'
     dateFormat = 'MM/dd/yyyy' => '99/99/9999'
 */


var convertDateFormatToMask = function convertDateFormatToMask(dateFormat) {
  return dateFormat.replace(/[A-Za-z]/gi, '9');
};

var TextStyle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DesktopInput__TextStyle",
  componentId: "sc-1r3v0kp-0"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme,
      enableFontSizeChange = _ref.enableFontSizeChange;
  return enableFontSizeChange ? "".concat(theme.fontSize.XSmall) : "".concat(theme.fontSize.normal);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.fontWeight.normal);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.lineHeight.normal);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.colors.neutral);
});
var StyledInputMask = (0, _styledComponents.default)(_reactInputMask.default).withConfig({
  displayName: "DesktopInput__StyledInputMask",
  componentId: "sc-1r3v0kp-1"
})(["outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:none;border-radius:5px;height:46px;font-size:1rem;line-height:20px;background:transparent;color:transparent;width:", ";font-family:", ";caret-color:", ";text-align:", ";padding:", ";&::placeholder{color:", ";opacity:0.5;text-transform:uppercase;}&:focus,&:-internal-autofill-selected{padding:", ";&::placeholder{padding:", ";}}"], function (props) {
  return props.variableWidth && '100%';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.neutral;
}, function (props) {
  return props.alignContentRight && 'end';
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.XXXSmall, " 0");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyDark;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.XXXSmall, " 0");
}, function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.space.none, ";");
});
StyledInputMask.displayName = 'StyledInputMask';

var DisplayValue = _styledComponents.default.div.withConfig({
  displayName: "DesktopInput__DisplayValue",
  componentId: "sc-1r3v0kp-2"
})(["position:absolute;top:22px;user-select:none;display:flex;padding:", ";", ""], function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.XXXSmall, " ").concat(theme.space.none);
}, function (_ref12) {
  var isOnlyApplyForHotel = _ref12.isOnlyApplyForHotel;
  return isOnlyApplyForHotel && (0, _styledComponents.css)(["top:27px;"]);
});

DisplayValue.displayName = 'DisplayValue';
var MaskText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DesktopInput__MaskText",
  componentId: "sc-1r3v0kp-3"
})(["opacity:0.5;color:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.greyDark;
});

var Day = _styledComponents.default.div.withConfig({
  displayName: "DesktopInput__Day",
  componentId: "sc-1r3v0kp-4"
})(["opacity:50%;font-size:", ";font-family:", ";margin-top:", ";margin-left:", ";"], function (_ref14) {
  var theme = _ref14.theme,
      enableFontSizeChange = _ref14.enableFontSizeChange;
  return enableFontSizeChange ? "".concat(theme.fontSize.semiXSmall) : "".concat(theme.fontSize.XSmall);
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontFamily.default;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.micro;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.micro;
});

var DesktopInput = function DesktopInput(_ref18) {
  var dayValue = _ref18.dayValue,
      tabIndex = _ref18.tabIndex,
      theme = _ref18.theme,
      placeholder = _ref18.placeholder,
      dateFormat = _ref18.dateFormat,
      value = _ref18.value,
      variableWidth = _ref18.variableWidth,
      alignContentRight = _ref18.alignContentRight,
      isOnlyApplyForHotel = _ref18.isOnlyApplyForHotel,
      enableFontSizeChange = _ref18.enableFontSizeChange,
      other = (0, _objectWithoutProperties2.default)(_ref18, _excluded);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var mask = convertDateFormatToMask(dateFormat);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value && /*#__PURE__*/_react.default.createElement(DisplayValue, {
      isOnlyApplyForHotel: isOnlyApplyForHotel
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/_react.default.createElement(TextStyle, {
      accessible: false,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      enableFontSizeChange: enableFontSizeChange
    }, value), dayValue && /*#__PURE__*/_react.default.createElement(Day, {
      enableFontSizeChange: enableFontSizeChange
    }, "(", dayValue, ")")), /*#__PURE__*/_react.default.createElement(MaskText, {
      accessible: false
    }, dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.slice(value === null || value === void 0 ? void 0 : value.length, dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.length).toUpperCase())), /*#__PURE__*/_react.default.createElement(StyledInputMask, (0, _extends2.default)({
      tabIndex: tabIndex,
      value: value,
      placeholder: placeholder,
      alwaysShowMask: true,
      mask: mask,
      variableWidth: variableWidth,
      maskChar: "",
      alignContentRight: alignContentRight
    }, other)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

DesktopInput.propTypes = _DesktopInput.default.PropTypes;
DesktopInput.defaultProps = _DesktopInput.default.DefaultProps;
var _default = DesktopInput;
exports.default = _default;